import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-terms',
  templateUrl: './privacy-terms.component.html',
  styleUrls: ['./privacy-terms.component.scss'],
})
export class PrivacyTermsComponent {
  creditType: string;
  country: string = '';

  constructor() {
    this.creditType = sessionStorage.getItem('creditType')!;
    this.country = sessionStorage.getItem('language')!;
  }
}
